<template>
  <!-- <v-app class="app-bg" :style="{fontFamily: font}"> -->
  <v-app class="app-bg" style="font-family: Poppins, sans-serif;">
    <v-overlay v-if="appInfo == null" color="white" :value="true">
      <v-progress-circular color="#e83e4b" indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <template v-else>
      <v-app-bar app color="#fecb3a" flat class="justify-center">
        <v-toolbar-title v-if="appInfo" class="title pl-0">
          <strong style="font-family: Poppins, sans-serif;">
            {{ appInfo.company_name }}
            <!-- <span :style="{color: appInfo.top_bar_color}" v-html="appInfo.company_name"></span> -->
          </strong>
        </v-toolbar-title>
      </v-app-bar>

      <v-content>
        <v-card tile class="mx-auto max-width-600 d-flex flex-column fill-height">
          <!-- <v-card-text> -->
          <v-container style="height: 30%">
            <v-img height="100%" contain :src="logo"></v-img>
          </v-container>

          <v-card
            tile
            class="fill-height"
            color="#e83e4b"
            style="border-top-left-radius: 42px; border-top-right-radius: 42px; border-bottom-left-radius: 0; border-bottom-right-radius: 0;"
          >
            <v-card-text class="px-8">
              <h2
                style="font-family: Poppins, sans-serif !important;"
                class="text-center white--text display-1"
              >{{ appContent.title ? appContent.title : "Benvenuto!"}}</h2>
              <!-- <v-form style="width: 100%" class="px-4"> -->
              <v-row>
                <v-col>
                  <h3
                    class="text-center white--text display-1"
                  >{{ appContent.subtitle ? appContent.subtitle : "Prenota" }}</h3>
                </v-col>
              </v-row>

              <v-row>
                <v-col class="pb-0">
                  <h3 class="mb-2 white--text">Quanti siete?</h3>

                  <v-text-field
                    @keypress="isNumber"
                    type="number"
                    style="font-size: 0.9rem;"
                    rounded
                    solo
                    single-line
                    placeholder="inserisci qui il numero di persone"
                    v-model="numero_ospiti"
                    :rules="[rules.required, rules.higherThanZero, rules.lowerOrEqual]"
                    :error="peopleError"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col class="pt-0">
                  <p
                    class="white--text text-center mb-0"
                  >{{ appContent.text ? appContent.text : "Per la prenotazione, ti servirà un numero di telefono e il tuo nome" }}</p>
                </v-col>
              </v-row>

              <!-- </v-form> -->
              <v-btn
                :loading="btnLoading"
                color="white"
                style="position: absolute; right: 0;"
                :style="{ color: '#e83e4b' }"
                class="mr-4 my-4"
                fab
                large
                bottom
                right
                @click="openConto"
              >
                <v-icon style="font-size: 2.5rem;">mdi-arrow-right</v-icon>
              </v-btn>
            </v-card-text>
          </v-card>
          <!-- </v-card-text> -->
        </v-card>
        <!-- <v-container>
        </v-container>-->
      </v-content>
    </template>
    <!-- <v-footer
      v-if="showFooter != 0 && appInfo.cookie_banner"
      app
      color="#fff"
      class="pa-8 font-weight-medium"
    >-->
  </v-app>
</template>

<script>
import { CDNClient } from "@/cdnClient";

export default {
  name: "App",
  data: vm => ({
    host:
      location.hostname == "localhost"
        ? "demoristorante.smoody.it"
        : location.hostname,
    btnLoading: false,
    pin: "",
    items: [],
    numero_ospiti: null,
    peopleError: false,
    appInfo: null,
    appContent: null,
    rules: {
      required: value => !!value || "Obbligatorio.",
      higherThanZero: value => Number(value) > 0 || "Deve essere più di zero",
      lowerOrEqual: value =>
        Number(value) <= Number(vm.appInfo.max_ospiti) ||
        `Massimo ${vm.appInfo.max_ospiti} ospiti`
    }
  }),
  created() {
    window.addEventListener("scroll", this.handleScroll);
    this.getAppInfo();
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  computed: {
    logo() {
      return "logotipo-stelline.png";

      // return `https://${this.host}/fl_config/${host}/img/3.jpg`;
    },
    mainColor() {
      if (this.appInfo.main_color) {
        return this.appInfo.main_color;
      }
      return "#000";
    },
    cols() {
      if (this.$vuetify.breakpoint.name == "lg") {
        return 4;
      }

      if (this.$vuetify.breakpoint.name == "md") {
        return 6;
      }
      return 12;
    },
    font() {
      if (this.appInfo) {
        if (this.appInfo.font) {
          return this.appInfo.font;
        }
      }
      return "Roboto, sans-serif !important";
    }
  },
  methods: {
    isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    handleScroll() {
      if (this.showFooter == true) {
        this.hideFooter();
      }
    },
    hideFooter() {
      this.showFooter = false;
      localStorage.setItem("showFooter", 0);
    },
    mainColorContrast(item) {
      if (item.main_color_contrast) {
        return this.$store.item.main_color_contrast;
      }
      return "#fff";
    },
    goTo(url, id, tag) {
      window.location.href = `${url}?b=${id}&tag=${tag}`;
    },
    getAppInfo() {
      CDNClient.get(`?get_app&custom_host=${this.host}&token=1`)
        .then(response => {
          if (response.data.esito == "KO") {
            alert(response.data.message);
          } else {
            this.appInfo = response.data.dati[0];
            this.getAppContent(response.data.dati[0].qrcode);
          }
        })
        .catch(error => alert(error));
    },
    getAppContent(qr) {
      CDNClient.get(
        `?get_app_contents&token=1&qrcode=${qr}&content_tag=booking`
      )
        .then(response => {
          if (response.data.esito == "KO") {
            alert(response.data.message);
          } else {
            this.appContent = response.data.dati[0];
          }
        })
        .catch(error => alert(error));
    },
    openConto() {
      this.btnLoading = true;

      if (
        !this.numero_ospiti ||
        Number(this.numero_ospiti) > Number(this.appInfo.max_ospiti)
      ) {
        this.peopleError = true;
        this.btnLoading = false;
        return;
      }

      CDNClient.get(
        `?open_conto&custom_host=${this.host}&token=1&pinConto=PRENOTAZIONE&numero_ospiti=${this.numero_ospiti}&tipo_ordine=TAVOLO`
      )
        .then(response => {
          this.btnLoading = false;
          if (response.data.esito == "KO") {
            alert(response.data.message);
          } else {
            this.goForward(response.data.redirect);
          }
          console.log(response);
        })
        .catch(error => {
          this.btnLoading = false;
          alert(error);
          console.log(error);
        });
    },
    goForward(redirect) {
      window.location.href = `https://${this.host}/${redirect}`;
    }
  }
};
</script>

<style>
.v-messages__message {
  color: white !important;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.app-bg {
  background-color: #f8f9fa !important;
}

.v-toolbar__content {
  justify-content: center;
}

div.v-input__slot {
  padding-top: 0.6rem !important;
  padding-bottom: 0.6rem !important;

  border: 3px solid #fecb3a;
}

.v-btn--example {
  bottom: 0;
  position: absolute;
  margin: 0 0 16px 16px;
}

@media only screen and (min-width: 900px) {
  .max-width-600 {
    max-width: 600px !important;
  }
}
</style>
